export const GMB_MEDIA_TYPE = {
  ADDITIONAL: { ID: 1, NAME: "ADDITIONAL" },
  COVER: { ID: 2, NAME: "COVER" },
  LOGO: { ID: 3, NAME: "LOGO" },
  EXTERIOR: { ID: 4, NAME: "EXTERIOR" },
  INTERIOR: { ID: 5, NAME: "INTERIOR" },
  PRODUCT: { ID: 6, NAME: "PRODUCT" },
  FOOD_AND_DRINK: { ID: 7, NAME: "FOOD_AND_DRINK" },
  TEAMS: { ID: 8, NAME: "TEAMS" }
};
